import { Flex, Typography } from 'antd';
import PropTypes from 'prop-types';

const { Text } = Typography;

const Legend = ({ items, color }) => {
  const circleStyle = {
    height: '0.75rem',
    width: '0.75rem',
    borderRadius: '50%',
  };

  return (
    <Flex gap="middle" align="center" wrap="wrap" className="legend">
      {items?.map(item => (
        <Flex gap="small" key={item?.key} align="center" justify="center">
          <div
            color="transparent"
            style={{ ...circleStyle, backgroundColor: item?.color }}
          ></div>
          <Text style={{ fontSize: '1rem', color }}>{item?.label}</Text>
        </Flex>
      ))}
    </Flex>
  );
};

Legend.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  color: PropTypes.string,
};

export default Legend;
